export const PAYMENT = `{
  id
  partner_id
  authorized_read
  invoice_url
  products
  expires_at
  start_at
  price
  payment_service
  spaces_count
  unused_space_count
  career_count
  seat_count
  campaign_credits
  is_trial
  unused_campaign_credits
  hirings_count
  status
  payment_type
  createdAt
  updatedAt
  __typename
}`

// PAYMENT plus plan (Backend feat/payment-plan). Nie in PAYMENT aufnehmen.
// Fehlt das Feld auf einer Stage, lehnt AppSync die ganze Query ab, deshalb
// laufen die Queries mit diesem Set nur, wenn die Schema-Probe
// (src/api/capabilities.js) paymentPlan meldet.
export const PAYMENT_WITH_PLAN = PAYMENT.replace(
  /\n {2}__typename\n}$/,
  '\n  plan\n  __typename\n}'
)
